export type RouteSection =
  | 'home'
  | 'search'
  | 'place'
  | 'person'
  | 'company'
  | 'invoice'
  | 'negotiation'
  | 'cancellation'
  | 'users'
  | 'upload'
  | 'other'

type RouteContext = {
  routeSection: RouteSection
  entityId?: string
}

/**
 * Derives a coarse navigation section (and the entity id when present) from a
 * pathname. Attached to every `$pageview` so PostHog insights can be filtered
 * and grouped by which interface an attendant is on, instead of relying on raw
 * URLs that carry high-cardinality ids.
 */
export const getRouteContext = (pathname: string): RouteContext => {
  const segments = pathname.split('/').filter(Boolean)
  const [first, second, third] = segments

  if (segments.length === 0) return { routeSection: 'home' }

  if (first === 'lugares' || first === 'pessoas') {
    return { routeSection: 'search' }
  }

  if (first === 'lugar' && second) {
    if (third === 'contas') return { routeSection: 'invoice', entityId: second }
    return { routeSection: 'place', entityId: second }
  }

  if (first === 'pessoa' && second) {
    return { routeSection: 'person', entityId: second }
  }

  if (first === 'empresa' && second) {
    return { routeSection: 'company', entityId: second }
  }

  if (pathname.includes('negocia')) return { routeSection: 'negotiation' }
  if (pathname.includes('cancelamento')) {
    return { routeSection: 'cancellation' }
  }

  if (first === 'usuarios') return { routeSection: 'users' }
  if (first === 'upload-contas') return { routeSection: 'upload' }

  return { routeSection: 'other' }
}
